import styled from 'styled-components'

export default styled.div`
  max-width: 500px;
  margin: auto;
  margin-top: 50px;
`
